import { Card, CardContent } from "@/components/ui/card";
import { Button } from "@/components/ui/button";
import { Shield, CheckCircle, ArrowRight } from "lucide-react";
import AdminLayout from "@/components/admin/AdminLayout";
import { Helmet } from "react-helmet-async";

const AdminEinstellungen = () => {
  return (
    <>
      <Helmet>
        <title>Einstellungen | Admin</title>
        <meta name="robots" content="noindex, nofollow" />
      </Helmet>

      <AdminLayout>
        {/* Hero Section */}
        <section className="mb-12">
          <h1 className="text-4xl md:text-5xl font-bold text-foreground mb-4">
            Einstellungen
          </h1>
          <p className="text-lg text-muted-foreground max-w-3xl">
            Verwalte die Einstellungen deiner Anwendung
          </p>
        </section>

        {/* CTA Section im Card-Layout */}
        <section>
          <div className="max-w-4xl">
            <Card className="bg-card/50 backdrop-blur-sm border-primary/20 hover:border-primary/40 transition-all duration-300">
              <CardContent className="p-6 sm:p-8 lg:p-10">
                <div className="flex flex-col lg:flex-row items-start gap-6">
                  {/* Icon */}
                  <div className="flex-shrink-0">
                    <div className="w-12 h-12 sm:w-14 sm:h-14 rounded-lg bg-primary/10 flex items-center justify-center">
                      <Shield className="w-6 h-6 sm:w-7 sm:h-7 text-primary" />
                    </div>
                  </div>

                  {/* Content */}
                  <div className="flex-grow space-y-4">
                    <h2 className="text-2xl sm:text-3xl font-bold text-foreground">
                      Jetzt persönliche Beratung sichern
                    </h2>
                    
                    <p className="text-base sm:text-lg text-muted-foreground">
                      Erhalten Sie eine maßgeschneiderte Cyberversicherung für Ihre Praxis. 
                      Kostenlose Erstberatung und individuelles Angebot.
                    </p>

                    {/* Benefits */}
                    <ul className="space-y-3">
                      <li className="flex items-start gap-3">
                        <CheckCircle className="w-5 h-5 text-primary flex-shrink-0 mt-0.5" />
                        <span className="text-foreground">Umfassender Schutz für Ihre Praxisdaten</span>
                      </li>
                      <li className="flex items-start gap-3">
                        <CheckCircle className="w-5 h-5 text-primary flex-shrink-0 mt-0.5" />
                        <span className="text-foreground">24/7 Notfall-Hotline bei Cyberangriffen</span>
                      </li>
                      <li className="flex items-start gap-3">
                        <CheckCircle className="w-5 h-5 text-primary flex-shrink-0 mt-0.5" />
                        <span className="text-foreground">Experten-Support von spezialisierten Beratern</span>
                      </li>
                    </ul>

                    {/* CTA Buttons */}
                    <div className="flex flex-col sm:flex-row gap-4 pt-4">
                      <Button size="lg" className="group">
                        Jetzt beraten lassen
                        <ArrowRight className="w-5 h-5 ml-2 group-hover:translate-x-1 transition-transform" />
                      </Button>
                      <Button size="lg" variant="outline">
                        Mehr erfahren
                      </Button>
                    </div>
                  </div>
                </div>
              </CardContent>
            </Card>
          </div>
        </section>
      </AdminLayout>
    </>
  );
};

export default AdminEinstellungen;
